/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShapeStanding = {
    properties: {
        placement: {
            type: 'number',
            isRequired: true,
        },
        team: {
            type: 'TeamListWithoutLeagues',
            isRequired: true,
        },
        matches: {
            type: 'array',
            contains: {
                type: 'MatchMini',
            },
            isRequired: true,
        },
    },
} as const;
